import {reaction} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {Disposers} from '../../../../../lib/helpers';
import {EditContentStore} from '../../../x7/content-parts/EditContentStore';
import {FlashcardsModel} from '../models';
import {FlashcardsEditStore} from './FlashcardsEditStore';
import {flashcardsEditStoreRenderer} from './FlashcardsEditStoreRenderer';

@observer
export class FlashcardsEdit extends React.Component<{ store: EditContentStore }> {
  readonly store: FlashcardsEditStore;
  readonly disposers = new Disposers();

  constructor(props: Readonly<{ store: EditContentStore }>) {
    super(props);

    this.store = new FlashcardsEditStore();
    const value = props.store.content.Contents;
    const model = JSON.parse(value) as FlashcardsModel;
    this.store.sync(model);

    this.setup();
  }

  render() {
    return Array.from(flashcardsEditStoreRenderer(this.store));
  }

  private setup() {
    this.disposers.add(
      reaction(
        () => this.store.valid,
        (valid) => this.props.store.setValid(valid),
        {fireImmediately: true}),
      reaction(
        () => this.store.x9Contents,
        (contents) => this.props.store.setContents(contents),
        {fireImmediately: true}));
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }
}
